import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Table, Params, Actions } from 'nallian-table-builder-ui';
import { INFINITE_SCROLL } from '../../../impersonationRequests/constants';
import { IMPERSONATION_REQUEST_ACTIONS } from '../../constants';
import {
  DurationCell,
  TargetUserCell,
  RequesterCell,
  DocumentAccessLabel,
} from 'nallian-shared-ui/lib/impersonation';
import DocumentAccessFilter from '../../../impersonationRequests/components/table/DocumentAccessFilter';
import TargetFilter from '../../../impersonationRequests/components/table/TargetFilter';
import ImpersonationRequestDetailModal from './ImpersonationRequestDetailModal';
import apiRoutes from '../../../../app/api/routes';

const SORT_SETTINGS = {
  defaults: { createdOn: 'asc' },
};

const ORG_IMPERSONATION_RESOURCE = 'orgImpersonationRequests';

const ImpersonationRequestsTab = ({ organisationId, urlRoot }) => {
  const { t } = useTranslation();
  const { action, actionId } = useParams();

  return (
    <>
      <ImpersonationRequestDetailModal
        open={organisationId && action === IMPERSONATION_REQUEST_ACTIONS.VIEW && !!actionId}
        rootUrl={urlRoot}
      />
      <Table
        infiniteScroll={INFINITE_SCROLL}
        resource={ORG_IMPERSONATION_RESOURCE}
        url={`${apiRoutes.impersonationRequests()}?OrganisationId=${organisationId}&Status=2`}
        noResultsMessage={t('noImpersonationRequestsFound')}
        pageSize={50}
        rowHeight={52}
        filtered
        sorted={SORT_SETTINGS}
        noUserSettings
        resizable
      >
        <Actions.Link
          width="2.5rem"
          align="center"
          icon="eye"
          url={`${urlRoot}/impersonation-requests/${IMPERSONATION_REQUEST_ACTIONS.VIEW}/:id`}
        />
        <Params.Custom
          filter={TargetFilter}
          content={TargetUserCell}
          label="targetUser"
          name="target"
          width="18rem"
          minWidth="16rem"
          grow
          noSort
        />
        <Params.Custom
          content={RequesterCell}
          label="requester"
          name="requester"
          width="18rem"
          minWidth="16rem"
          grow
          noSort
          noFilter
        />
        <Params.Custom
          content={DurationCell}
          label="duration"
          name="requestedDuration"
          sortName="duration"
          width="7rem"
          noFilter
        />
        <Params.String name="reason" label="reason" width="10rem" noFilter noSort />
        <Params.String name="ticketReference" label="ticketProjectReference" width="10rem" noSort />
        <Params.Custom
          filter={DocumentAccessFilter}
          content={DocumentAccessLabel}
          label="documentAccess"
          name="documentAccessEnabled"
          width="8rem"
        />
        <Params.DateTime
          name="createdOn"
          label="requestedAt"
          sortName="requestedAt"
          width="10rem"
          noFilter
        />
      </Table>
    </>
  );
};

ImpersonationRequestsTab.propTypes = {
  organisationId: PropTypes.string.isRequired,
  urlRoot: PropTypes.string.isRequired,
};

export default ImpersonationRequestsTab;
